import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';
import { BusinesscoItem, DepartmentItem, LogisticService, StockplaceItem } from '@app/services/logistic.service';
import { PurchaseStatusItem, PurchHeadCreateGet, PurchHeadService, PurchHeadsGetParams, SavePurchHeadCreateResponse } from '@app/services/purch-head.service';
import { TypeaheadService } from '@app/services/typeahead.service';

@GridModalComponent('purchheadcreate')
@Component({
    selector: 'tt-purch-head-create',
    templateUrl: './purch-head-create.component.html',
    styleUrls: ['./purch-head-create.component.css'],
})
export class PurchHeadCreateComponent implements OnInit, OnChanges {
    @Input()
    public params?: PurchHeadsGetParams;

    public get?: PurchHeadCreateGet;

    public purchaseStatuses: PurchaseStatusItem[] = [];

    public companies: BusinesscoItem[] = [];

    public stockplaces: StockplaceItem[] = [];

    public departments: DepartmentItem[] = [];

    public saving = false;

    @Output()
    public submit = new EventEmitter<SavePurchHeadCreateResponse>();

    constructor(
        private logistic: LogisticService,
        private purchhead: PurchHeadService,
        private modal: ModalService,
        private state: StateService,
        private typeahead: TypeaheadService,
        @Optional() @Inject(TT_STATE_DIALOG) context: StateDialogContext,
    ) {
        this.initFromDialog(context);
    }

    public searchSuppliers = () => {
        return this.typeahead.searchCustomer({ cust_name: this.get?.searchtext_supplier || '', custtype: 'S', lastselect: 'SEARCH' });
    };

    public onSupplierSelected(event?: Item) {
        if (!this.get) return;

        this.get.supplier_no = event?.item_id ?? '0';
        this.get.searchtext_supplier = event?.item_name ?? '';
    }

    public async openSelectProject() {
        const response = await this.modal.openStateDialog({ state: 'selectproject', params: `${this.params?.argtype}/${this.params?.argvalue}` });

        if (!!response) {
            this.loadGet();
        }
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;

            const response = await this.purchhead.savePurchHeadCreate(this.get);

            if ('' + response.errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response.errormessage });
            } else {
                this.submit.emit(response);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.purchhead.getPurchHeadCreate(this.params);
        }
    }

    private async loadPurchaseStatuses() {
        this.purchaseStatuses = await this.purchhead.getPurchaseStatuses({ createnew: '1' });
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies();
    }

    private async loadStockplaces() {
        if (!!this.get) {
            this.stockplaces = await this.logistic.getStockplaces({ businessco_no: '' + this.get.businessco_no });
        }
    }

    private async loadDepartments() {
        if (!!this.get) {
            this.departments = await this.logistic.getDepartments(this.get.businessco_no);
        }
    }

    private async init() {
        delete this.get;
        await this.loadGet();
        this.loadStockplaces();
        this.loadDepartments();
    }

    ngOnInit(): void {
        this.loadPurchaseStatuses();
        this.loadCompanies();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }

    private async initFromDialog(context: StateDialogContext) {
        if (!!context) {
            context.setSize({ width: 'min(98vw, 70rem)' });
            this.params = context.params as unknown as PurchHeadsGetParams;
            context.setHeading('p2_m_purchheadcreate', true);
            await this.init();
            this.submit.subscribe({
                next: (response: SavePurchHeadCreateResponse) => {
                    if (!!response.webpagename) {
                        this.state.go(response.webpagename, response.parms);
                    }

                    context.close(response);
                },
            });
        }
    }
}
